export default __webpack_public_path__ + "src/_images/CustService_Icon.svg";